import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map, shareReplay, tap } from "rxjs/operators";
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StreetService {
  private http = inject(HttpClient);
  private calles$: Observable<any> | null = null;
  private readonly STORAGE_KEY = 'streets.calles';

  constructor() {}

  preload(): void {
    this.getCalles().subscribe({ error: () => {} });
  }

  clearCache(): void {
    this.calles$ = null;
    sessionStorage.removeItem(this.STORAGE_KEY);
  }

  getCalles(): Observable<any> {
    if (this.calles$) {
      return this.calles$;
    }

    const cached = sessionStorage.getItem(this.STORAGE_KEY);
    if (cached) {
      try {
        this.calles$ = of(JSON.parse(cached)).pipe(shareReplay(1));
        return this.calles$;
      } catch {
        sessionStorage.removeItem(this.STORAGE_KEY);
      }
    }

    const headers = new HttpHeaders({ 'Content-type': 'application/json' });

    this.calles$ = this.http.get('streets', { headers }).pipe(
      tap((response) => {
        try { sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(response)); } catch {}
      }),
      shareReplay(1)
    );

    return this.calles$;
  }
  getRegiones(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.http
      .get('streets/regiones', { headers: headers })
      .pipe(map((response) => response));
  }

  getComunas(): Observable<any> {
    let headers = new HttpHeaders({
      'Content-type': 'application/json',
    });

    return this.http
      .get('streets/comunas', { headers: headers })
      .pipe(map((response) => response));
  }

  getInfo_propiedad_direccion(calle: string, num: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let params = {
      calle: calle,
      num: num,
    };
    return this.http
      .post("streets/find-by-address", params, {
        headers: headers,
      })
      .pipe(map((response) => response));
  }
  getInfo_propiedad_rol(rol: string) {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });
    let params = {
      rol: rol
    };
    return this.http
      .post("streets/find-by-rol", params, {
        headers: headers,
      })
      .pipe(map((response) => response));
  }
}
